import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import type { LoginEduFormViewData } from '@sites/entity-core/src/widget/login-edu/styles/login-edu.css-vars';

/**
 * Read-only preview of the sign-in form as the visitor will see it. Purely
 * presentational — every class list and CSS variable arrives on `data`; see
 * `login-edu-view.css-vars.ts`.
 */
@Component({
    selector: 'web-login-form-view',
    templateUrl: './login-form-view.component.html',
    styleUrls: ['./login-form-view.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class LoginFormViewComponent {
    public readonly data = input.required<LoginEduFormViewData>();
    public readonly showRegistrationFormLink = input<boolean>(false);
}
